export default{
    autManagement:{
        titleBox:{
            title1:'认证类型',
            title2:'身份认证',
            title3:'(免费)',
            title4:'认证内容',
            title5:'认证状态',
        },
        showList:{
            show1:'平台审核',
            show2:'认证失败',
            show3:'已认证',
            show4:'未认证',
            show5:'操作',
            show6:'立即认证',
            show7:'查看详情',
            show8:'个人',
            show9:'个人实名认证是指身份证信息的核实，来证明会员身份的真实性。 通过个人实名认证后，可以证明您身份的真实性，更好的促进长期交易，在发生交易异议时，您的投诉会被优先受理并获得解决',
            show10:'企业',
            show11:'企业完成企业身份认证，认证后将获得多重特权，买方双方交易更放心、 做生意更容易。'
        },

        autManageDetail:{
            anage1:'您已经提交信息，请耐心等待审核。审核周期1-2个工作日',
            anage2:'当前暂未通过个人身份认证。请修改后重新提交。',
            anage3:'申请时间：',
            anage4:'认证状态：',
            anage5:'平台审核',
            anage6:'认证失败',
            anage7:'认证成功',
            anage8:'审核备注：',
            anage9:'姓名：',
            anage10:'性别：',
            anage11:'身份证号码：',
            anage12:'身份证号码有效期：',
            anage13:'联系手机：',
            anage14:'证件信息：',
            anage15:'身份证正面',
            anage16:'身份证反面',
            anage17:'手持身份证正面照',
            anage18:'编辑',
            anage19:'返回我的认证',
            
        },
        entpAuth:{
            entpAuth1:'申请企业认证并审核成功后，该账号将变更为企业账号',
            entpAuth2:'企业',
            entpAuth3:'企业名称：',
            entpAuth4:'注册地区：',
            entpAuth5:'详细地址：',
            entpAuth6:'联系人姓名：',
            entpAuth7:'联系人手机：',
            entpAuth8:'营业执照：',
            entpAuth9:'取消',
            entpAuth10:'提交审核',
            entpAuth11:'保存成功',

        },
        entpAuthFrom:{
            rule1:'请输入企业名称',
            rule2:'请输入4-50字的企业名称',
            rule3:'请选择注册地址',
            rule4:'请输入详细地址',
            rule5:'请输入2-50字的详细地址',
            rule6:'请输入联系人姓名',
            rule7:'请输入2-20字的联系人姓名',
            rule8:'请输入联系人手机号',
            rule9:'请输入正确的手机号',
            rule10:'请上传营业执照',
            rule11:'营业执照支持不大于10M，格式为jpg，jepg，png的图片',
            rule12:'请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息'
        },
        entpAuthDetail:{
            entp1:'您已经提交信息，请耐心等待审核。审核周期1-2个工作日',
            entp2:'您当前暂未通过企业身份认证',
            entp3:'申请时间：',
            entp4:'审核状态：',
            entp5:'审核中',
            entp6:'审核通过',
            entp7:'审核拒绝',
            entp8:'审核备注：',
            entp9:'企业名称：',
            entp10:'联系人姓名：',
            entp11:'联系人手机号：',
            entp12:'注册地址：',
            entp13:'营业执照：',
            entp14:'编辑',
            entp15:'返回我的认证',
        }
    }
    
}